import { createFileRoute } from '@tanstack/react-router';

import { trendsRouteBeforeLoad, trendsRouteLoader } from '@/utils/trends/trends-route';

export const Route = createFileRoute('/$org/$agent/reports')({
  beforeLoad: trendsRouteBeforeLoad,
  loader: trendsRouteLoader,
});
